<script lang="ts">
    import Button from "../../materialize/components/Button.svelte";
    import Chip from "../../materialize/components/Chip.svelte";
    import Icon from "../../materialize/components/Icon.svelte";
    import Divider from "../../materialize/grid/Divider.svelte";
    import Panel from "../../materialize/components/Panel.svelte";
    import {
        current_dialect,
        current_expanded_result_id,
        italian_language,
    } from "../../stores/stores";
    import type { Word } from "../../dictionary/Word";
    import { languages } from "../../stores/stores";
    import TranslationDetails from "./TranslationDetails.svelte";
    import Row from "../../materialize/grid/Row.svelte";
    import VerticalAlign from "../../materialize/grid/VerticalAlign.svelte";
    import Column from "../../materialize/grid/Column.svelte";
import ShareButton from "../../utils/ShareButton.svelte";
import { BASE_URL_SHARE } from "../../settings";
    let my_panel: Panel;
    export let word: Word;
    function expand() {
        $current_expanded_result_id = word.id;
        my_panel.focus();
    }
    export const close = () => {
        expanded = false;
    };
    $: expanded = $current_expanded_result_id === word.id;
</script>

<Panel
    bind:this={my_panel}
    class_list={expanded ? ["highlight_panel"] : []}
    
>
    <Row>
        <Column small={12}>
            <Chip>
                {$languages
                    .find((l) => l.id == word.language)
                    .short_name.toUpperCase()}
            </Chip>
        </Column>
        <Column small={12}>
            {#if !expanded}
                <h5 class="left">{word.word}</h5>
                <Button on:click={() => {
                    expand();
                }} flat={true} class_list={["right"]}
                    >TRADUCI <Icon icon="expand_more" /></Button
                >
            {/if}
        </Column>
    </Row>

    {#if expanded}
        <TranslationDetails word_to_translate={word} />
    {/if}
    <Row>
        <Column>
            <ShareButton
                class_list={["right"]}
                share_title={`Scopri la traduzione di "${word.word}" su Appröu`}
                share_url={`${BASE_URL_SHARE}/#/parola/${word.id}`}
                share_text="{`Scopri la traduzione di "${word.word}" su Appröu\n\n ➡ ${BASE_URL_SHARE}/#/parola/${word.id}`}">
            </ShareButton>
        </Column>
    </Row>
    
</Panel>
